import { render, staticRenderFns } from "./salesSummary.vue?vue&type=template&id=2f69ae02&scoped=true&"
import script from "./salesSummary.vue?vue&type=script&lang=js&"
export * from "./salesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f69ae02",
  null
  
)

export default component.exports